<template>
  <v-container class="progress-goalSetting-behaviourChangeGoals pb-0">
    <v-row>
      <v-col cols="12" lg="6" class="mt-2 pr-8">
        <v-row no-gutters>
          <v-col cols="3 offset-6" align="center">
            <h3>{{ $t("journeyBehaviourChangeGoals.status") }}</h3>
          </v-col>
          <v-col cols="3" align="center">
            <h3>{{ $t("journeyBehaviourChangeGoals.motivation") }}</h3>
          </v-col>
        </v-row>
        <goal-setting-behaviour-change-goal-status
          :v-if="behaviourGoals.length !== 0"
          v-for="behaviourChangeComponent in behaviourChangeComponents"
          :key="behaviourChangeComponent.name"
          :behaviourComponent="$app.behaviourComponentManager.getBehaviourComponentName(behaviourChangeComponent.name)"
          :icon="behaviourChangeComponent.icon"
          :behaviourChange="behaviourGoals.get(behaviourChangeComponent.name)"
        >
        </goal-setting-behaviour-change-goal-status>
      </v-col>
      <v-col cols="12" lg="6" class="mt-2 border-left pl-14 pr-10 pb-3">
        <v-row no-gutters>
          <v-col >
            <h3>{{ $t("journeyBehaviourChangeGoals.decision") }}</h3>
          </v-col>
        </v-row>
        <v-row class="progress-goalSetting-behaviourChangeGoals__decision pt-3">
          <v-col cols="3" align="center" class="border-right-dashed">
            <p>{{ $t("physicalActivityStepGoals.inactive", { catalog: 'app_mobile' }) }}</p>
          </v-col>
          <v-col cols="3" align="center">
            <p>{{ $t("journeyBehaviourChangeGoals.startAction") }}</p>
          </v-col>
          <!-- Note: Release 2.0 scope reduction  -->
          <!-- <v-col cols="2" align="center">
            <p>{{ $t("journeyBehaviourChangeGoals.plannedAction") }}</p>
          </v-col> -->
          <v-col cols="3" align="center">
            <p>
              {{ $t("journeyBehaviourChangeGoals.monitoredAction") }}
            </p>
          </v-col>
          <v-col cols="3" align="center">
            <p>
              {{ $t("journeyBehaviourChangeGoals.maintainedBehavior") }}
            </p>
          </v-col>
        </v-row>
        <behaviour-component-decision-drag-and-drop
          :behaviourComponent="'MEDICATIONS'"
          :allowedLevels="[
            'inactive',
            'monitored_action',
            'maintained_behaviour',
          ]"
          icon="mdi-pill"
          :activeLevel="$store.getters['patientSummary/getBehaviourComponent']('MEDICATIONS').levelOfGuidance"
          :enabled="isModuleEnabled('MEDICATIONS')"
        />

        <behaviour-component-decision-drag-and-drop
          :behaviourComponent="'STARTMOVING'"
          :allowedLevels="[
            'inactive',
            'start_action',
            // 'planned_action',
            'monitored_action',
            'maintained_behaviour',
          ]"
          icon="mdi-run"
          :activeLevel="$store.getters['patientSummary/getBehaviourComponent']('STARTMOVING').levelOfGuidance"
          :enabled="isModuleEnabled('STARTMOVING')"
        />

        <behaviour-component-decision-drag-and-drop
          :behaviourComponent="'HEALTHYNUTRITION'"
          :allowedLevels="['inactive', 'start_action', 'monitored_action', 'maintained_behaviour']"
          icon="mdi-silverware-fork-knife"
          :activeLevel="$store.getters['patientSummary/getBehaviourComponent']('HEALTHYNUTRITION').levelOfGuidance"
          :enabled="isModuleEnabled('HEALTHYNUTRITION')"
        />

        <behaviour-component-decision-drag-and-drop
          :behaviourComponent="'SMOKECESSATION'"
          :allowedLevels="['inactive', 'start_action', 'monitored_action', 'maintained_behaviour']"
          icon="mdi-smoking-off"
          :activeLevel="$store.getters['patientSummary/getBehaviourComponent']('SMOKECESSATION').levelOfGuidance"
          :enabled="isModuleEnabled('SMOKECESSATION')"
        />

        <behaviour-component-decision-drag-and-drop
          :behaviourComponent="'STRESSMANAGEMENT'"
          :allowedLevels="['inactive', 'start_action', 'monitored_action', 'maintained_behaviour']"
          icon="mdi-meditation"
          :activeLevel="$store.getters['patientSummary/getBehaviourComponent']('STRESSMANAGEMENT').levelOfGuidance"
          :enabled="isModuleEnabled('STRESSMANAGEMENT')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import BehaviourComponentDecisionDragAndDrop from "../../../components/Parts/BehaviourComponentDecisionDragAndDrop.vue";
import GoalSettingBehaviourChangeGoalStatus from "../../../components/Parts/GoalSettingBehaviourChangeGoalStatus.vue";
import { mapGetters, mapState } from "vuex";

/**
 * Component ProgressGoalSettingBehaviourChangeGoals.vue
 *
 * @module ProgressGoalSettingBehaviourChangeGoals
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/views/Patient/Progress/ProgressGoalSettingBehaviourChangeGoals.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "ProgressGoalSettingBehaviourChangeGoals",
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
      visit1Date: "patientSummary/visit1Date",
      behaviourGoals: "patientSummary/behaviourGoals",
      isModuleEnabled: "enabledModules/getIsModuleEnabled",
    }),
    ...mapState({
      behaviourComponents: (state) => state.patientSummary.behaviourComponents
    }),
  },
  created() {},
  data: function () {
    return {
      behaviourChangeComponents: [
        { name: "MEDICATIONS", icon: "mdi-pill" },
        { name: "STARTMOVING", icon: "mdi-run" },
        { name: "HEALTHYNUTRITION", icon: "mdi-silverware-fork-knife" },
        { name: "SMOKECESSATION", icon: "mdi-smoking-off" },
        { name: "STRESSMANAGEMENT", icon: "mdi-meditation" },
      ],
      visibleJourneyProgress: [
        {
          // behaviour component
          behaviourChangeGoal: "MEDICATIONS",
          // LOG
          guidance_level: "0",
          // Position based different logic / LOG
          behaviourChangeGoalPosition: 0,
          // active
          active: false,
        },
        {
          behaviourChangeGoal: "STARTMOVING",
          guidance_level: "0",
          behaviourChangeGoalPosition: 1,
          active: false,
        },
        {
          behaviourChangeGoal: "HEALTHYNUTRITION",
          guidance_level: "0",
          behaviourChangeGoalPosition: 4,
          active: false,
        },
        {
          behaviourChangeGoal: "SMOKECESSATION",
          guidance_level: "0",
          behaviourChangeGoalPosition: 2,
          active: false,
        },
        {
          behaviourChangeGoal: "STRESSMANAGEMENT",
          guidance_level: "0",
          behaviourChangeGoalPosition: 3,
          active: false,
        },
      ],
      overTimeChartBehaviourGoalsData: [[null], [null], [null], [null], [null]],
    };
  },
  watch: {},
  methods: {},
  mounted: async function () {
    // Get latest patientSummary in case a change in LoGs has happened in the meantime (in mobile app)
    this.$store.dispatch('patientSummary/update');

    // Refetch every 60 seconds.
    setInterval(() => {
      this.$store.dispatch('patientSummary/update');
    }, 60 * 1000);

    const journeyCalculator = this.$app.patientManager.makeJourneyCalculator(
      this.patientId,
      moment(this.visit1Date)
    );
    await journeyCalculator.loadMyBehaviourComponentLogs();
    this.visibleJourneyProgress = journeyCalculator.visibleJourneyProgress.data;
    this.overTimeChartBehaviourGoalsData =
      journeyCalculator.overTimeChartBehaviourGoalsData;
  },
  components: {
    BehaviourComponentDecisionDragAndDrop,
    GoalSettingBehaviourChangeGoalStatus,
  },
};
</script>

<style lang="scss">

.progress-goalSetting-behaviourChangeGoals__decision {
  p {
    font-size: 1.1rem;
  }
}
</style>
